module.exports = __webpack_public_path__ + "img/icon_qp_n_c.52029260.png";